
export default {
	install(Vue) {
		Vue.prototype.$formatDate = function(obsDt, locale = null) {
			if (!obsDt) return obsDt;
			const [y, m, d] = obsDt.split('-').map(Number);
			const date = new Date(y, m - 1, d);
			const loc = locale || window.navigator.language || 'en-US';
			const day   = new Intl.DateTimeFormat(loc, { day: 'numeric' }).format(date);
			const month = new Intl.DateTimeFormat(loc, { month: 'short' }).format(date);
			const year  = new Intl.DateTimeFormat(loc, { year: 'numeric' }).format(date);
			return `${day} ${month} ${year}`;
		};
	}
};
